var map = {
	"./1.jpeg": 774,
	"./10.jpeg": 5911,
	"./2.jpeg": 7313,
	"./3.jpeg": 5567,
	"./4.jpeg": 4377,
	"./5.jpeg": 7072,
	"./9.jpeg": 5562
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5486;